import { TruncatedText, TextBlank } from 'UiKit/typography';

import ActionButton from 'View/reschedule/component/action-button';
import AttachmentImage from 'Component/attachment-image';
import StatusBadge from 'View/reschedule/component/status-badge';

import styles from './styles.module.css';

const buildTableListRequested = (t, onOpenPreview) => [
  {
    name: t('requesterName'),
    key: 'hostName',
    width: 180,
    component: ({ value }) => (
      <TruncatedText className={styles['column__text']}>
        <TextBlank as="span">{value}</TextBlank>
      </TruncatedText>
    ),
  },
  {
    name: 'Brand',
    key: 'hostBrands',
    width: 150,
    position: 'center',
    component: ({ value }) => (
      <TruncatedText className={styles['column__text']}>
        <TextBlank as="span">{value}</TextBlank>
      </TruncatedText>
    ),
  },
  {
    name: t('requestType'),
    key: 'type',
    width: 150,
    component: ({ value }) => (
      <TruncatedText className={styles['column__text']}>
        <TextBlank as="span">{value}</TextBlank>
      </TruncatedText>
    ),
  },
  {
    name: t('alternateSchedule'),
    key: 'replacementSchedule',
    width: 240,
    position: 'center',
    component: ({ value }) => (
      <TruncatedText className={styles['column__text']}>
        <TextBlank as="span">{value}</TextBlank>
      </TruncatedText>
    ),
  },
  {
    name: t('alternateHost'),
    key: 'replacementHost',
    width: 150,
    component: ({ value }) => (
      <TruncatedText className={styles['column__text']}>
        <TextBlank as="span">{value}</TextBlank>
      </TruncatedText>
    ),
  },
  {
    name: t('attachments'),
    key: 'images',
    width: 100,
    component: ({ value }) => {
      const images = value ? value.map((item) => ({ url: item })) : [];
      return <AttachmentImage images={images} onOpenPreview={onOpenPreview} />;
    },
  },
  {
    name: t('status'),
    key: 'statusProgress',
    width: 120,
    position: 'center',
    component: ({ value }) => {
      return <StatusBadge status={value}>{value}</StatusBadge>;
    },
  },
  {
    name: 'Action',
    key: 'id',
    width: 200,
    position: 'center',
    rightSticky: 0,
    component: ({ values }) => <ActionButton values={values} />,
  },
];

export default buildTableListRequested;
